<div class="animate-fadeIn">
  <!-- This branch's plan (clinic app + CRM), from the platform's plan lifecycle. -->
  <app-branch-plan-card class="block mb-12" />

  <div *ngIf="isLoadingSubscription()" class="flex flex-col items-center justify-center py-20">
    <div class="h-10 w-10 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
    <p class="mt-4 text-slate-400 text-[10px] font-black uppercase tracking-widest">{{ 'subscription_loading' |
      translate }}</p>
  </div>

  <div *ngIf="!isLoadingSubscription() && (subscriptionData$ | async) as data">
      <!-- Bottom Section: Payment History -->
      <div class="flex flex-col gap-6">
        <h3 class="text-xs font-black uppercase tracking-[0.2em] text-slate-500">{{ 'subscription_payment_history' |
          translate }}</h3>
        <div class="overflow-x-auto rounded-2xl border border-slate-100 bg-white shadow-sm">
          <table class="w-full text-left min-w-[800px]">
            <thead class="bg-slate-50/50 border-b border-slate-50">
              <tr>
                <th class="px-6 py-4 text-[10px] font-black uppercase tracking-widest text-slate-400">{{
                  'subscription_renewal_date' | translate }}</th>
                <th class="px-6 py-4 text-[10px] font-black uppercase tracking-widest text-slate-400">{{
                  'subscription_payment_value' | translate }}</th>
                <th class="px-6 py-4 text-[10px] font-black uppercase tracking-widest text-slate-400">{{
                  'subscription_payment_method' | translate }}</th>
                <th class="px-6 py-4 text-[10px] font-black uppercase tracking-widest text-slate-400">{{
                  'subscription_payment' | translate }}</th>
                <th class="px-6 py-4 text-[10px] font-black uppercase tracking-widest text-slate-400">{{
                  'subscription_payment_status' | translate }}</th>
                <th class="px-6 py-4 text-[10px] font-black uppercase tracking-widest text-slate-400 text-right">{{
                  'subscription_payment_actions' | translate }}</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-slate-50">
              <tr *ngFor="let payment of (paymentHistory$ | async)" class="hover:bg-slate-50/50 transition-all">
                <td class="px-6 py-4 text-sm text-slate-600 font-medium">{{ payment.renovation_date || '----' }}</td>
                <td class="px-6 py-4 text-sm text-primary font-black">€{{ payment.payment_value || '----' }}</td>
                <td class="px-6 py-4 text-sm text-slate-600 font-medium">{{ payment.payment_method || '----' }}</td>
                <td class="px-6 py-4 text-sm text-slate-600 font-medium">{{ payment.payment_date || '----' }}</td>
                <td class="px-6 py-4">
                  <span class="px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest"
                    [class.bg-emerald-50]="payment.payment_status_title === 'Pago'"
                    [class.text-emerald-600]="payment.payment_status_title === 'Pago'"
                    [class.bg-amber-50]="payment.payment_status_title !== 'Pago'"
                    [class.text-amber-600]="payment.payment_status_title !== 'Pago'">
                    {{ payment.payment_status_title ? (getFinancialStatusKey(payment.payment_status_title) | translate) : '----' }}
                  </span>
                </td>
                <td class="px-6 py-4 text-right">
                  <div class="flex items-center justify-end">
                    <button *ngIf="payment.payment_method === 'Multibanco'" (click)="showPaymentModal(payment)"
                      class="p-2 text-slate-400 hover:text-primary hover:bg-primary-light/50 rounded-lg transition-all"
                      [title]="'subscription_payment_action_visualize' | translate">
                      <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
              <tr *ngIf="(paymentHistory$ | async)?.length === 0">
                <td colspan="6" class="px-6 py-16 text-center">
                  <div class="flex flex-col items-center justify-center text-slate-400 gap-3">
                    <svg class="w-12 h-12 opacity-20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                        d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
                    </svg>
                    <span class="text-sm font-medium">{{ 'subscription_no_information' | translate }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
  </div>

  <!-- Modals -->
  <div *ngIf="currentModalState !== 'none'"
    class="fixed inset-0 z-[1000] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm animate-fadeIn p-4">
    <div
      class="bg-white rounded-[2rem] shadow-2xl w-full max-w-2xl flex flex-col relative overflow-hidden animate-zoomIn">
      <!-- Common Header -->
      <div class="p-8 flex items-center justify-between border-b border-slate-50">
        <h3 class="text-lg font-bold text-slate-800 uppercase tracking-tight">{{ 'subscription_modal_plan_title' |
          translate }}</h3>
        <button (click)="closeModal()"
          class="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-50 rounded-full transition-all">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Modal Content Area -->
      <div class="p-8 overflow-y-auto max-h-[70vh]">

        <!-- State: Missing Info -->
        <div *ngIf="currentModalState === 'missing_info'" class="flex flex-col items-center text-center gap-8 py-4">
          <div class="w-20 h-20 bg-amber-50 rounded-full flex items-center justify-center text-amber-500">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div class="flex flex-col gap-3 max-w-md">
            <p class="font-bold text-slate-800 text-xl">{{ 'subscription_modal_oops' | translate }}</p>
            <p class="text-slate-500 leading-relaxed text-sm">
              {{ 'subscription_modal_go_to_tab' | translate }}
              <span class="font-bold text-slate-900">{{ 'subscription_modal_clinic' | translate }}</span>
              {{ 'subscription_modal_on_screen' | translate }}
              <span class="font-bold text-slate-900">{{ 'subscription_modal_settings' | translate }}</span>
              {{ 'subscription_modal_ensure_data' | translate }}
            </p>
          </div>
          <button (click)="closeMissingInfoModalAndNavigate()"
            class="h-12 px-12 bg-primary text-white text-[10px] font-black uppercase tracking-widest rounded-full hover:bg-primary-hover shadow-lg shadow-primary/20 transition-all">
            {{ 'common_ok' | translate }}
          </button>
        </div>

        <!-- State: Plan Details -->
        <div *ngIf="currentModalState === 'plan_details'"
          class="flex flex-col items-center gap-10 py-4 animate-slideUp">
          <div
            class="bg-slate-50 rounded-3xl border border-slate-100 p-8 flex flex-col items-center gap-6 w-full max-w-[320px] shadow-sm">
            <div class="w-24 h-24 bg-white rounded-2xl shadow-sm p-4 border border-slate-50">
              <img src="assets/images/image_renovar_assinatura.png" alt="Plan" class="w-full h-full object-contain">
            </div>

            <div class="flex flex-col items-center text-center gap-2">
              <h4 class="text-xl font-bold text-slate-800">{{ selectedPlan?.title || '---' }}</h4>
              <div class="flex items-baseline gap-1">
                <span class="text-3xl font-black text-primary">€ {{ selectedPlan?.subscription_value || '---' }}</span>
                <span class="text-sm font-medium text-slate-400">{{ 'per_month_suffix' | translate }}</span>
              </div>
              <p class="text-[10px] font-black uppercase tracking-widest text-slate-400 mt-2">{{
                'subscription_modal_renovation' | translate }}</p>
            </div>
          </div>

          <div class="max-w-md text-center">
            <p class="text-slate-500 text-sm leading-relaxed">
              {{ 'subscription_modal_contact_1' | translate }}
              <span class="font-bold text-primary">{{ 'subscription_modal_contact_email' | translate }}</span>
              {{ 'subscription_modal_contact_2' | translate }}
            </p>
          </div>
        </div>

        <!-- State: Cancel Confirmation -->
        <div *ngIf="currentModalState === 'cancel_confirmation'"
          class="flex flex-col items-center gap-10 py-4 text-center">
          <div class="w-20 h-20 bg-rose-50 rounded-full flex items-center justify-center text-rose-500">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </div>
          <div class="flex flex-col gap-3 max-w-sm">
            <h4 class="text-xl font-bold text-slate-800">{{ 'subscription_modal_cancel_title' | translate }}</h4>
            <p class="text-slate-500 text-sm leading-relaxed">
              {{ 'subscription_modal_cancel_confirm' | translate }}
            </p>
          </div>

          <div class="flex items-center gap-4 w-full max-w-xs">
            <button (click)="closeModal()"
              class="flex-1 h-12 border border-slate-200 text-slate-600 font-bold rounded-2xl hover:bg-slate-50 transition-all uppercase tracking-wide text-xs">
              {{ 'common_no' | translate }}
            </button>
            <button (click)="confirmCancelSubscription()"
              class="flex-1 h-12 bg-rose-500 text-white font-bold rounded-2xl hover:bg-rose-600 shadow-lg shadow-rose-100 transition-all uppercase tracking-wide text-xs">
              {{ 'yes' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>